import SystemSettings from "./settings"

export default SystemSettings
